export const FACEBOOK_SHARE =   `https://www.facebook.com/eafruits`
export const INSTAGRAM_SHARE =   `https://www.instagram.com/eafoodsltd/`
export const TWITTER_SHARE =   `https://twitter.com/EAFoodsLtd`
export const LINKEDIN_SHARE =   `https://tz.linkedin.com/company/ea-fruits-farm-&-co`
